import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { LcPoolSummary } from './useLiquidityCachePools';

interface UseLcPoolReturn {
  pool: LcPoolSummary | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useLiquidityCachePool(poolId: string | undefined): UseLcPoolReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.liquidityCaches.pool(poolId!),
    queryFn: () => api.getLiquidityCachePool(poolId!),
    enabled: !!poolId,
  });

  return {
    pool: data ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load pool' : null,
    refresh: () => {
      refetch();
    },
  };
}
